import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { VariableBenefitAccountDetails } from '../../../../../../../models/transactions/variable-benefit-account-details';
import { VbAccountAnnualDetails } from '../../../../../../../models/transactions/vb-account-annual-details';
import {
  currentVbPlanYear,
  findVbBandForAccountYear,
  vbAccountYear
} from '../../../../variable-benefit-accounts/utils/vb-annual-details-utils';

@Component({
  selector: 'app-vb-payment-change-age-for-minimum-calculation-jurisdiction',
  templateUrl: './vb-payment-change-age-for-minimum-calculation-jurisdiction.component.html',
  styleUrls: ['./vb-payment-change-age-for-minimum-calculation-jurisdiction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeAgeForMinimumCalculationJurisdictionComponent implements OnChanges {
  @Input({ required: true }) account!: VariableBenefitAccountDetails;

  public accountYear = currentVbPlanYear();
  public band: VbAccountAnnualDetails | null = null;

  public ngOnChanges(): void {
    this.accountYear = vbAccountYear(this.account);
    this.band = findVbBandForAccountYear(this.account);
  }
}
